import { call, put, select, takeEvery } from "redux-saga/effects";
import { fetchedUnPairedCameraDevices, types, updateDevices, updateCompanionDeviceSite, updateCameraOnboaredDetails, getCameraCredsSuccess, getCameraCredsFailure, showCalibrationBanner } from "../actions";
import { checkStreamCalibration } from "../../global/utility/Utils";
import { NOTIFICATION_TYPES, TITLES, SUBTITLES } from "../../constants/cameraInfoConstants";
import { activateSensorEndPoint } from "../../configuration";
import api from "../../api/utils";
import {
  refreshDevices,
  fetchAllCompanionDevices,
  fetchAllCameraAndFovsForRbac,
  getDiscoveredCamerasForSingleCompanion,
  updateOnboardedDetails,
  getCameraCreds
} from "../../api/DeviceServiceManager";

function* DeviceSaga() {
  yield takeEvery(types.ACTIVATE_SENSOR, workActivateSensors);
  yield takeEvery(types.UPDATE_CAMERA_ON_BOARED_REQ, updateCameraOnboarded);
  yield takeEvery(types.FETCH_ALL_DEVICES, fetchAllDevices);
  yield takeEvery(types.FETCH_ALL_COMPANION_DEVICES, getAllCompanionDevices);
  yield takeEvery(types.FETCH_ALL_CAMERA_AND_FOVS_DEVICES, getAllCameraAndFovDevices);
  yield takeEvery(types.GET_DISCOVERED_CAMERAS_FOR_COMP, getDiscoveredCamerasForSingleComp);
  yield takeEvery(types.GET_CAMERA_CREDS_REQUEST, getCameraCredsWorker);
}

const activeSession = (state) => state.sessionReducer.activeSession;

function* workActivateSensors({ sensors }) {
  const session = yield select(activeSession);
  const currentSession = session.activeSession;
  const tobeActivatedSensors = sensors.filter((sensor) => sensor.checkboxSelected && !sensor.checkboxDisabled);
  if (tobeActivatedSensors.length > 0) {
    const toBeActivateSensorDeviceId = tobeActivatedSensors[0].id;
    const tobeActivatedSensor = {
      accountname: currentSession.accountId,
      resourceidentifier: { deviceid: toBeActivateSensorDeviceId }
    };
    try {
      // const url = activateSensorEndPoint();
      // const response = yield call(
      //   api({ url, payload: tobeActivatedSensor, method: "POST" })
      // );
      // console.log("Activat Sensor", response);
      // yield put({
      //   type: types.ACTIVATE_SENSOR_SUCCESS,
      //   payload: toBeActivateSensorDeviceId,
      // });
      // yield put({
      //   type: types.SET_SHOW_SENSOR_ACTIVATE_MODAL,
      //   payload: {
      //     showSensorActivatedModal: true,
      //     activationStatusMessage:
      //       "Your requested sensor will be activated shortly.",
      //   },
      // });
      yield put({
        type: types.SET_SHOW_SENSOR_ACTIVATE_MODAL,
        payload: {
          showSensorActivatedModal: true
        }
      });
    } catch (err) {
      console.log(err);
      yield put({
        type: types.SET_SHOW_SENSOR_ACTIVATE_MODAL,
        payload: {
          showSensorActivatedModal: true
        }
      });
    }
  }
}

function* fetchAllDevices() {
  const session = yield select(activeSession);
  const currentSession = session.activeSession;
  const refreshedDevices = yield call(refreshDevices, currentSession.accountId);
  yield put(updateDevices(refreshedDevices));
}

function* getAllCompanionDevices() {
  try {
    const session = yield select(activeSession);
    const devices = yield call(fetchAllCompanionDevices, session.activeSession);
    yield put(updateCompanionDeviceSite(devices.companiondevices));
  } catch (error) {
    console.log("Error while getting CV Apps -> " + error);
  }
}

function* getAllCameraAndFovDevices(action) {
  try {
    const session = yield select(activeSession);
    const cameraAndFovDevices = yield call(fetchAllCameraAndFovsForRbac, session.activeSession);
    const cameras = cameraAndFovDevices.cameras;
    const fovs = cameraAndFovDevices.fovs;
    yield put(
      updateDevices({
        cameraList: cameras,
        fovList: fovs
      })
    );
    const bannerInfo = yield select((state) => state.calibrationBanner.bannerInfo);
    if (
      bannerInfo?.showNotification &&
      bannerInfo?.type === NOTIFICATION_TYPES.STREAM_CALIBRATION &&
      fovs?.length > 0 &&
      !checkStreamCalibration(bannerInfo?.deviceId || cameras || [], fovs)
    ) {
      const streamFov = fovs?.find(f => f.parentdeviceid === bannerInfo.deviceId);
      const streamName = streamFov?.name;
      yield put(showCalibrationBanner({ showNotification: false }));
      yield put(showCalibrationBanner({
        showNotification: true,
        type: "Success",
        priority: "success",
        title: streamName ? `${streamName} ${TITLES.STREAM_CALIBRATION_COMPLETE}` : TITLES.STREAM_CALIBRATION_COMPLETE,
        subtitle: SUBTITLES.STREAM_CALIBRATION_COMPLETE,
        isDismissible: true,
      }));
    }
    if (action?.meta) {
      action.meta.resolve();
    }
  } catch (error) {
    console.log("Error while getting CV Apps -> " + error);
    if (action?.meta) {
      action.meta.resolve();
    }
  }
}

function* updateCameraOnboarded(action) {
  try {
    const session = yield select(activeSession);
    const response = yield call(updateOnboardedDetails, action.payload, session.activeSession);
    yield put(updateCameraOnboaredDetails(response));
  } catch (error) {
    console.log("Error while getting CV Apps -> " + error);
  }
}

function* getDiscoveredCamerasForSingleComp(action) {
  try {
    const session = yield select(activeSession);
    yield call(getDiscoveredCamerasForSingleCompanion, action?.payload, session.activeSession);
  } catch (error) {
    console.log("Error while getting discovered cameras for single comp -> " + error);
  }
}

function* getCameraCredsWorker(action) {
  try {
    const session = yield select(activeSession);
    const response = yield call(getCameraCreds, action.payload, session.activeSession);
    yield put(getCameraCredsSuccess(response));
  } catch (error) {
    yield put(getCameraCredsFailure(error.message || "Failed to fetch camera credentials"));
  }
}

export default DeviceSaga;
